import { createFileRoute } from '@tanstack/react-router';
import { BusinessPage } from '../components/pages/BusinessPage/BusinessPage';

export const Route = createFileRoute('/account/business')({
  component: BusinessPage,
});
